import React, {
  useState,
  useCallback,
  useContext,
  useEffect,
  useRef
} from 'react';
import AdditionalReminderCardSettingsView from '../view/AdditionalReminderCardSettingsView';
import GeneralContext from '../../GeneralContext';

export const WHO_ADMIN_GROUP = ['specific', 'assignee', 'all_admins'];
//export  const WHO_EU_GROUP = ['submitter'];

const AdditionalReminderCardSettingsEngine = ({ reminderData, update }) => {
  const api = useContext(GeneralContext);
  const { formAdmins } = api;

  const [selectedAdmin, setSelectedAdmin] = useState(
    reminderData.whoSpecificIds[0] || (formAdmins[0] && formAdmins[0].id) || ' '
  );

  const pendingWho = useRef(null);
  const [
    isConfirmEmailTemplateOverrideDialogOpen,
    setIsConfirmEmailTemplateOverrideDialogOpen
  ] = useState(false);

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (reminderData.who === 'specific') {
      updateSelectedAdmin(selectedAdmin);
    }
  }, [reminderData.who]);

  useEffect(() => {
    // compensate for async data loading
    if (!reminderData.whoSpecificIds[0] && formAdmins[0]) {
      setSelectedAdmin(formAdmins[0].id);
    }
  }, [formAdmins]);

  const updateSelectedAdmin = useCallback(
    selectedAdminId => {
      setSelectedAdmin(selectedAdminId);
      update({ whoSpecificIds: [selectedAdminId] });
    },
    [update, setSelectedAdmin]
  );

  const onWhoChanged = useCallback(
    value => {
      const oldValue = reminderData.who;

      const isNewValueInAdminGroup = WHO_ADMIN_GROUP.includes(value);
      const isOldValueInAdminGroup = WHO_ADMIN_GROUP.includes(oldValue);

      if (
        reminderData.emailTemplateId &&
        isNewValueInAdminGroup !== isOldValueInAdminGroup
      ) {
        // if they customized the email and we need to load template from a different group
        pendingWho.current = value;
        setIsConfirmEmailTemplateOverrideDialogOpen(true);
        return;
      }

      update({ who: value });
    },
    [reminderData]
  );
  const onConfirmOverride = useCallback(() => {
    setIsConfirmEmailTemplateOverrideDialogOpen(false);
    update({ who: pendingWho.current, emailTemplateId: undefined });
    pendingWho.current = null;
  }, [update]);

  const viewProps = {
    reminderData,
    update,
    selectedAdmin,
    updateSelectedAdmin,
    onWhoChanged,
    isConfirmEmailTemplateOverrideDialogOpen,
    setIsConfirmEmailTemplateOverrideDialogOpen,
    onConfirmOverride
  };
  return <AdditionalReminderCardSettingsView {...viewProps} />;
};

export default AdditionalReminderCardSettingsEngine;
